module.exports = "pegasus/assets/blocks/column-10-theme4.png";